// ── 직원 모달 전용 스타일 (2026-09-09 UserModals.jsx 301줄 분리) ────────────
//   컴포넌트 파일에 섞여 있던 상수만 옮겼다. 값은 그대로다.
import { btn } from './styles';

// 날짜 입력칸 안쪽 라벨 (2026-08-27 사용자 명세 — type=date 는 placeholder 불가라 라벨을 칸 안에 겹침)
const dateLabelStyle = {
  position: 'absolute',
  left: 12,
  top: '50%',
  transform: 'translateY(-50%)',
  fontSize: 13,
  color: 'var(--text-muted)',
  pointerEvents: 'none',
};

const futureSchedulePanelStyle = {
  gridColumn: '1 / -1',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: 12,
  border: '1px solid var(--border)',
  borderRadius: 8,
  padding: '10px 12px',
  background: 'var(--bg-subtle)',
};

const futureScheduleTitleStyle = {
  fontSize: 12,
  fontWeight: 800,
  color: 'var(--text)',
};

const futureScheduleTextStyle = {
  marginTop: 3,
  fontSize: 12,
  color: 'var(--text-muted)',
};

const futureScheduleCancelBtnStyle = {
  ...btn,
  borderColor: '#ef4444',
  color: '#dc2626',
  background: 'var(--bg-card)',
  whiteSpace: 'nowrap',
};

export {
  dateLabelStyle,
  futureSchedulePanelStyle,
  futureScheduleTitleStyle,
  futureScheduleTextStyle,
  futureScheduleCancelBtnStyle,
};
